export default {
  SET_STATE: (state, payload) => {
    state[payload.action] = payload.data
  },
  removeIngredient(state, i) {
    if (state.inventory) {
      state.inventory.ingredients.splice(i, 1)
    }
  }
}
